import React from "react";
import axios from "../../../../services/axios/backendAxios";
import { connect } from "react-redux";
import ActiveRouteCard from "../../../../components/Cards/ActiveRouteCard";
import LoadingIcon from "../../../../components/Loaders/LoadingIcon";
import { useQueryClient } from "@tanstack/react-query";
import useQueryActiveRoutes from "../../../../hooks/useQueryActiveRoutes";

/**
 * @deprecated use the map instead.
 */
const ActiveRouteCards = (props) => {
  const queryClient = useQueryClient();

  const activeRoutesQuery = useQueryActiveRoutes(
    props.currentUser.currentCompanyId,
  );

  const loading = activeRoutesQuery.isLoading;
  const activeRoutes = activeRoutesQuery.data?.activeRoutes;

  const refreshData = () => {
    queryClient.invalidateQueries({
      queryKey: [
        "company",
        props.currentUser.currentCompanyId,
        "activeRoutes-new",
      ],
    });
  };

  const handleDelete = async (e, uid) => {
    e.preventDefault();
    e.stopPropagation();

    // Display an alert asking if the user is sure they want to delete the route
    if (
      window.confirm(
        "Are you sure you want to discontinue this route? The active route will be discontinued, but no data will be lost.",
      )
    ) {
      await axios.delete(`activeRoute/operator/${uid}/delete`);
      refreshData();
    }
  };

  if (loading) return <LoadingIcon />;

  return (
    <div className="flex flex-1 flex-col w-full p-10 items-center overflow-y-scroll">
      <div className="w-full">
        {activeRoutes.map((route, key) => (
          <ActiveRouteCard
            route={route}
            key={key}
            onDelete={(e) => {
              handleDelete(e, route.operator.uid);
            }}
          />
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { currentUser } = state;
  return { currentUser };
};

export default connect(mapStateToProps)(ActiveRouteCards);
